import { ExcelStyle } from 'ag-grid-community';

export interface GICDimensionsInformation {
  areaInCmSq: number;
  widthInCm: number;
  lengthInCm: number;
  relativeSize: number;
}

export interface GICPartInformation {
  name: string;
  side: string;
}

export interface GICInformation {
  type: string;
  part: GICPartInformation;
  dimensions: GICDimensionsInformation;
}

export enum DamageTypeColour {
  DENT = '#ee17d5',
  CRACK = '#5fe8ff',
  SCRATCH = '#1dbd55',
  GLASS = '#9d49ec',
  MISSING = '#ff7300',
}

export const DamageTypeExcelStyles: ExcelStyle[] = [
  {
    id: 'damageTypeDENT',
    font: {
      color: '#ffffff',
      bold: true,
    },
    interior: {
      color: DamageTypeColour.DENT,
      pattern: 'Solid',
      patternColor: DamageTypeColour.DENT,
    },
  },
  {
    id: 'damageTypeCRACK',
    font: {
      color: '#ffffff',
      bold: true,
    },
    interior: {
      color: DamageTypeColour.CRACK,
      pattern: 'Solid',
      patternColor: DamageTypeColour.CRACK,
    },
  },
  {
    id: 'damageTypeSCRATCH',
    font: {
      color: '#ffffff',
      bold: true,
    },
    interior: {
      color: DamageTypeColour.SCRATCH,
      pattern: 'Solid',
      patternColor: DamageTypeColour.SCRATCH,
    },
  },
  {
    id: 'damageTypeGLASS',
    font: {
      color: '#ffffff',
      bold: true,
    },
    interior: {
      color: DamageTypeColour.GLASS,
      pattern: 'Solid',
      patternColor: DamageTypeColour.GLASS,
    },
  },
  {
    id: 'damageTypeMISSING',
    font: {
      color: '#ffffff',
      bold: true,
    },
    interior: {
      color: DamageTypeColour.MISSING,
      pattern: 'Solid',
      patternColor: DamageTypeColour.MISSING,
    },
  },
];
